import { Injectable } from "@angular/core";
import { AuthService, AuthStore } from "app/auth";
import { HistoryStore } from "./history";
import { ConversationService } from "./incoming";
import { ChatOpenStore } from "./open";

/** A service used to execute actions related to the lifecycle of the chatbot */
@Injectable({ providedIn: "root" })
export class ChatLifecycleService {
  private _switchedOff = false;

  constructor(
    private readonly chatOpenStore: ChatOpenStore,
    private readonly conversationService: ConversationService,
    private readonly historyStore: HistoryStore,
    private readonly authService: AuthService,
    private readonly authStore: AuthStore
  ) {}

  /** Initializes the conversation */
  initialize(): void {
    this.historyStore.clear();
    this.conversationService.initialize();
  }

  /** Clear the current conversation and relaunching a new one, re-verifying the session it will use */
  reset(): void {
    this.conversationService.reset();
    this.historyStore.clear();
    this.authService.cancelPendingAuthentication();
    this.authStore.rechargeAttempts();
    this.authService.reverifySession();
  }

  /** Close the chatbot and remove any messages */
  shutdown(): void {
    this.conversationService.clear();
    this.historyStore.clear();
    this.chatOpenStore.close();
    this.authService.cancelPendingAuthentication();
  }

  /** @return Whether the chat bot was switched off to display Dimelo */
  get switchedOff(): boolean {
    return this._switchedOff;
  }

  /** Notifies that the chat bot was switched off to display the external chat */
  notifySwitchedOff() {
    this._switchedOff = true;
    this.conversationService.clear();
    this.historyStore.clear();
    this.authService.cancelPendingAuthentication();
  }
}
